import { forwardRef } from 'react';
import { LandingBlock, LandingBlockProps } from '../LandingBlock/LandingBlock';
import { SmallCardProps } from '../../SmallCard/SmallCard';
import { Heading } from '../../Heading/Heading';

import styles from './LandingSmallCards.module.scss';

interface LandingSmallCardsProps extends LandingBlockProps {
  smallCards?: SmallCardProps[];
}

export const LandingSmallCards = forwardRef<
  HTMLElement,
  LandingSmallCardsProps
>(({ smallCards = [], documentTitle, ...props }, ref) => {
  const [featuredCard, ...metricCards] = smallCards;

  const getCardKey = (card: SmallCardProps) =>
    [card.bigText, card.smallText1, card.smallText2]
      .filter(Boolean)
      .join('-') || 'experience-card';

  const renderMetricCards = () => {
    return metricCards.map((card) => (
      <article key={getCardKey(card)} className={styles.metric}>
        <p className={styles['metric-value']}>{card.bigText}</p>
        <p className={styles['metric-label']}>
          {[card.smallText1, card.smallText2].filter(Boolean).join(' ')}
        </p>
      </article>
    ));
  };

  return (
    <LandingBlock
      {...props}
      documentTitle={documentTitle}
      classname={styles.block}
      ref={ref}
    >
      <div className={styles.content}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>Clinical background</span>
          <Heading className={styles.title} headingLevel="h2">
            {documentTitle}
          </Heading>
          <p className={styles.description}>
            A focused snapshot of medical training, patient trust, and
            specialized care built through years of practice.
          </p>
        </div>
        {featuredCard && (
          <article className={styles.featured}>
            <p className={styles['featured-value']}>{featuredCard.bigText}</p>
            <p className={styles['featured-label']}>
              {[featuredCard.smallText1, featuredCard.smallText2]
                .filter(Boolean)
                .join(' ')}
            </p>
          </article>
        )}
        <div className={styles.metrics}>{renderMetricCards()}</div>
      </div>
    </LandingBlock>
  );
});

LandingSmallCards.displayName = 'LandingSmallCards';
